import store from "@/store/index"
function setMode(){
  if(window.innerWidth < 992){
    store.commit('app/setMobileMode',true)
  }else{
    store.commit('app/setMobileMode',false)
    store.commit('app/CloseMobileSideBar')
    store.commit('app/CloseToolBar')
  }
}
setMode()

window.onresize = function(){
  setMode()
}